import { CalendarMonth, Delete } from "@mui/icons-material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useMemo, useState } from "react";

import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";
import AutoCompleteDropdown from "../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import {
  formatDateAppointment,
  getCenturyDateBounds,
  isWithinDateBounds,
  toValidDate,
} from "../../../../../ui library/helpers/functions";
import { useUploadDocumentStore } from "../../hooks/useUploadDocumentStore";

const BillAccordionSummary = ({ accordionItem }) => {
  const { provider } = useUploadDocumentStore();
  const { min: minDate, max: maxDate } = useMemo(() => getCenturyDateBounds(), []);
  const [hasDateError, setHasDateError] = useState(false);

  const handleDateChange = (newDate) => {
    const dateValue = toValidDate(newDate);
    if (!dateValue) {
      setHasDateError(false);
      accordionItem.updateScheduled(accordionItem.id, { date: null, hasError: false });
      return;
    }

    if (!isWithinDateBounds(dateValue, minDate, maxDate)) {
      setHasDateError(true);
      accordionItem.updateScheduled(accordionItem.id, { date: null, hasError: true });
      return;
    }

    setHasDateError(false);
    accordionItem.updateScheduled(accordionItem.id, {
      date: formatDateAppointment(dateValue),
      hasError: false,
    });
  };

  const providerTypeOptions =
    provider?.providerTypes?.map((type) => ({
      id: type.id,
      label: type.name,
    })) || [];
  const appointmentDate = toValidDate(accordionItem.appointment_date);
  const storedDateInvalid = Boolean(accordionItem.appointment_date) &&
    (!appointmentDate || !isWithinDateBounds(appointmentDate, minDate, maxDate));
  const displayDateError = hasDateError || storedDateInvalid;

  return (
    <div className="flex-flex-col w-full">
      <div className="flex w-full flex-row items-center">
        <div className="w-1/2 p-2">
          <AutoCompleteDropdown
            initValue={null}
            label="Provider Type"
            data={providerTypeOptions}
            onValueChange={(e, value) =>
              accordionItem.updateProviderTypeId(accordionItem.id, value)
            }
          />
        </div>
        <div className="w-1/2 p-2">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              value={appointmentDate}
              minDate={minDate}
              maxDate={maxDate}
              onChange={handleDateChange}
              onError={(reason, newValue) => {
                if (!reason) {
                  setHasDateError(false);
                  return;
                }

                const valueToCheck = toValidDate(newValue);
                const outOfRange = Boolean(valueToCheck) &&
                  !isWithinDateBounds(valueToCheck, minDate, maxDate);
                setHasDateError(Boolean(reason) || outOfRange);
              }}
              components={{
                OpenPickerIcon: CalendarMonth,
              }}
              slotProps={{
                inputAdornment: {
                  position: "end",
                },
                textField: {
                  error: displayDateError,
                },
              }}
              label="Appointment Date"
              className="w-full"
            />
          </LocalizationProvider>
        </div>
        <div>
          <CustomIconButton
            classes={"p-2"}
            iconVisible={true}
            CustomIcon={<Delete className="text-red-500" />}
            handleOnClick={() => accordionItem.deleteRow(accordionItem.id)}
          />
        </div>
      </div>
    </div>
  );
};

export default BillAccordionSummary;
